import * as React from "react"
import { CardModal, CardModalNotOkButton, CardModalType } from "../../modal"
import { ServiceGroup, LocalAuthority } from "../../../model"

export default class DetailGroupModalComponent
extends React.Component<DetailServiceModalComponentProps> {
	render() {
		const group = this.props.group
		const title = group
		? `Modifier le groupe "${group.label}"`
		: "Ajouter un groupe de services"
		const modalType = group ? CardModalType.ValidCancelDelete : CardModalType.ValidCancel

		return <CardModal active
		loading={this.props.loadingGroup || this.props.submitting}
		title={title}
		type={modalType}
		onClickCloseButton={this.props.onClickCloseButton}
		onClickDeleteButton={this.props.onClickDeleteButton}
		onClickFooterButton={this.props.onClickFooterButton}
		onSubmit={this.props.onSubmit}>
			{/* Champ libellé */}
			<div className="field">
				<label className="label" htmlFor={Ids.Label}>Nom du groupe</label>
				<div className="control">
					<input
					className="input"
					defaultValue={group ? group.label : null}
					disabled={this.props.submitting}
					id={Ids.Label}
					name={Names.Label}
					placeholder="Sport"
					required
					type="text" />
				</div>
			</div>
		</CardModal>
	}
}

export enum Names {
	Label = "label"
}

export interface DetailServiceModalComponentProps {
	loadingGroup: boolean
	localAuthority: LocalAuthority
	group?: ServiceGroup
	submitting: boolean
	onClickCloseButton(e: React.SyntheticEvent<Element>): void
	onClickDeleteButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

enum Ids {
	Label = "detail-service-label"
}


// WEBPACK FOOTER //
// ./src/component/services/detail-group-modal/detail-group-modal-component.tsx